import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { USER_KEY } from '../constants';
import { LocalStorageStore } from '../utils/localstorage-store';
import { User } from './user';
export var UserStore = /*#__PURE__*/function () {
  function UserStore(clientId, store) {
    _classCallCheck(this, UserStore);

    this.clientId = clientId;
    this.store = store || new LocalStorageStore();
    this.user = this.fetchUser();
  }

  _createClass(UserStore, [{
    key: "set",
    value: function set(user) {
      this.user = user;
      this.cacheUser(user);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.user = undefined;
      this.cacheUser(undefined);
    }
  }, {
    key: "fetchUser",
    value: function fetchUser() {
      var userData = this.store.getItem(this.storageKey);

      if (userData) {
        return User.fromString(userData);
      }
    }
  }, {
    key: "cacheUser",
    value: function cacheUser(user) {
      if (user) {
        this.store.setItem(this.storageKey, user.toStorageString());
      } else {
        this.store.clearItem(this.storageKey);
      }
    }
  }, {
    key: "currentUser",
    get: function get() {
      return this.user || this.fetchUser();
    }
  }, {
    key: "storageKey",
    get: function get() {
      return "".concat(USER_KEY, ".").concat(this.clientId);
    }
  }]);

  return UserStore;
}();